import LogIn from 'views/login/login.vue';
import Register from 'views/login/register.vue';
import BindPhone from 'views/login/bind-phone.vue';
export default [

  /*
    去掉登录注册
  * */

/*  {
    name: 'logIn',
    path: '/login',
    component: LogIn,
  },
  {
    name: 'register',
    path: '/register',
    component: Register,
  },*/
  {
    name: 'bindphone',
    path: '/bindphone',
    component: BindPhone
  },
  {
    name: 'disable',
    path: '/disable',
    component: () => import('views/login/disable.vue')
  }
];
